import Vue from 'vue'
import Vuex from 'vuex'

import FormFields from '../functions/FormFields'

Vue.use(Vuex)

const formFields = new FormFields()

export const formState = {
  namespace: undefined,
  fieldGroup: undefined,
  values: {},
  initialValues: gon.form_values || {},
  isSubmitting: false,
  isFailedSubmitting: false,
}

export const formGetters = {
  fields(state) {
    return formFields[state.fieldGroup ?? 'default']
  },
  fieldNames(_state, getters) {
    return getters.fields.map((field) => field.name)
  },
  currentUser() {
    return gon?.current_user || {}
  },
  getValues(state) {
    return state.values
  },
}

export const formMutations = {
  setNameSpace(state, value) {
    state.namespace = value
  },
  setFieldGroup(state, value) {
    state.fieldGroup = value
  },
  setValue(state, payload) {
    Vue.set(state.values, payload.name, payload.value)
  },
  setIsSubmitting(state, value) {
    state.isSubmitting = value
  },
  setIsFailedSubmitting(state, value) {
    state.isFailedSubmitting = value
  },
}

export const formActions = {
  initValues({ commit, state, getters }) {
    getters.fields.forEach((field) => {
      commit('setValue', {
        name: field.name,
        value: state.initialValues[field.name] ?? field.defaultValue,
      })

      if (field.subFields) {
        field.subFields.forEach((subField) => {
          commit('setValue', {
            name: subField.name,
            value: state.initialValues[subField.name] ?? subField.defaultValue,
          })
        })
      }
    })
  },
  onChangeValue({ commit, getters }, { name, value }) {
    commit('setValue', { name, value })
    commit('setIsFailedSubmitting', false)
  },
  onSubmit({ commit }) {
    commit('setIsSubmitting', true)
    commit('setIsFailedSubmitting', false)

    setTimeout(() => {
      commit('setIsSubmitting', false)
      commit('setIsFailedSubmitting', true)
    }, 30000)
  },
}
